module.exports = __webpack_public_path__ + "img/9-3.8950f27f.png";